import React, { useState, useEffect, useContext } from "react";
import { Button, Checkbox, Input, message, Form } from "antd";
import { Link, useHistory } from "react-router-dom";
import { context } from '../context'
// import CircularProgress from "components/CircularProgress/index";
import { EyeInvisibleOutlined, EyeTwoTone, UserOutlined, LockOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

const FormItem = Form.Item;

const SignIn = () => {

  const { state, actions } = useContext(context)
  const { authUser } = state;
  const { userSignIn } = actions;

  // const [form] = Form.useForm();
  const history = useHistory();

  const [disable, setDisable] = useState(false)

  useEffect(() => {
    if (authUser !== null) {
      history.push('/');
    }
  }, [authUser]);

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const onFinish = (values) => {
    setDisable(true)
    const result = userSignIn(values)
    result.then(res => {
      setDisable(false)
      if (!res.success) {
        message.error(res.error)
      }
    })
  };

  return (
    <div className="gx-login-container">
      <div className="gx-login-content">
        <div className={styles.container_logo}>
          <a className={styles.account__img} alt="" />
        </div>
        <Form
          layout={"vertical"}
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">

          <FormItem label="Correo" rules={[{ required: true, message: '¡Por favor ingresa tu correo!' }]} name="email">
            <Input prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder="Correo" />
          </FormItem>

          <FormItem label="Contraseña" rules={[{ required: true, message: '¡Por favor ingresa tu contraseña!' }]} name="password">
            <Input.Password prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
              iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              type="password"
              placeholder="Contraseña" />
          </FormItem>

          <FormItem name="remember" valuePropName="checked">
            {/* <Checkbox>Recordarme</Checkbox> */}
            <Link className="gx-login-form-forgot" to="#">¿Olvidaste tu contraseña?</Link>
          </FormItem>

          <FormItem className="gx-text-center">
            <Button type="primary" htmlType="submit" disabled={disable} block>
              Entrar
            </Button>
          </FormItem>

        </Form>
      </div>
    </div>
  );
};

export default SignIn;



// const SignIn = () => {

//   const { state, actions } = useContext(context)
//   const { loader, alertMessage, showMessage, authUser } = state;
//   const { userSignIn } = actions;

//   const [form] = Form.useForm();
//   const history = useHistory();

//   useEffect(() => {
//     if (showMessage) {
//       setTimeout(() => {
//         // dispatch(hideMessage());
//       }, 100);
//     }
//     if (authUser !== null) {
//       history.push('/');
//     }
//   });

//   // const handleSubmit = (e) => {
//   //   e.preventDefault();
//   //   props.form.validateFields((err, values) => {
//   //     if (!err) {
//   //       dispatch(showAuthLoader());
//   //       dispatch(userSignIn(values));
//   //     }
//   //   });
//   // };

//   const onFinishFailed = errorInfo => {
//     console.log('Failed:', errorInfo);
//   };

//   const onFinish = values => {
//     // localStorage.setItem('user_id', JSON.stringify("vZ8Q6IxQUtbYAjVL6Z1CTNgLqF93"));
//     // actions.showAuthLoader(true)
//     actions.userSignIn(values)
//     // actions.userSignIn(true)
//   };

//   return (
//     <div className="gx-app-login-wrap">
//       <div className="gx-app-login-container">
//         <div className="gx-app-login-main-content">
//           <div className="gx-app-logo-content">
//             <div className="gx-app-logo-content-bg">

//               <img src={"https://via.placeholder.com/272x395"} alt='Neature' />
//             </div>
//             <div className="gx-app-logo-wid">
//               <h1>ENARM</h1>
//               <p>By Signing Up, you can avail full features of our services.</p>
//               <p>Get an account !!!</p>
//             </div>
//             <div className="gx-app-logo">
//               <img alt="example" src={require("assets/images/logo.png")} />
//             </div>
//           </div>
//           <div className="gx-app-login-content">
//             <Form
//               initialValues={{ remember: true }}
//               name="basic"
//               onFinish={onFinish}
//               onFinishFailed={onFinishFailed}
//               className="gx-signin-form gx-form-row0">

//               <Form.Item
//                 initialValue="demo@example.com"
//                 rules={[{ required: true, message: 'The input is not valid E-mail!' }]} name="email">
//                 <Input placeholder="Email" />
//               </Form.Item>
//               <Form.Item
//                 initialValue="demo#123"
//                 rules={[{ required: true, message: 'Please input your Password!' }]} name="password">
//                 <Input type="password" placeholder="Password" />
//               </Form.Item>
//               <Form.Item>
//                 <Checkbox>by signing up, I accept</Checkbox>
//                 <span className="gx-signup-form-forgot gx-link">Term & Condition</span>
//               </Form.Item>
//               <Form.Item>
//                 <Button type="primary" className="gx-mb-0" htmlType="submit">
//                   Iniciar sesión
//                 </Button>
//                 {/* <span>or</span> <Link to="/signup">Sign Up</Link> */}
//               </Form.Item>
//               <div className="gx-flex-row gx-justify-content-between">
//                 <span>or connect with</span>
//                 <ul className="gx-social-link">
//                   <li>
//                     <GoogleOutlined
//                     // onClick={() => console.log()}
//                     />
//                   </li>
//                   <li>
//                     <FacebookOutlined
//                     // onClick={() => console.log()}
//                     />
//                   </li>
//                   {/* <li>
//                     <GithubOutlined
//                     />
//                   </li>
//                   <li>
//                     <TwitterOutlined
//                     />
//                   </li> */}
//                 </ul>
//               </div>
//               {/* <span
//                 className="gx-text-light gx-fs-sm"> demo user email: 'demo@example.com' and password: 'demo#123'</span> */}
//             </Form>
//           </div>

//           {loader ?
//             <div className="gx-loader-view">
//               <CircularProgress />
//             </div> : null}
//           {showMessage ?
//             message.error(alertMessage.toString()) : null}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SignIn;
